// extracted by mini-css-extract-plugin
module.exports = {"btn-line":"btn-line--11x55","order-num":"order-num--193q5","number-input":"number-input--IsvnC","delete-btn":"delete-btn--1nzX4"};